import { MessagingDetailsCard } from "@/components/atoms/interactionDetailsCard";
import {
	acceptGeneric,
	acceptGenericTransfer,
	rejectGeneric,
	rejectGenericTransfer,
} from "@/repository/queryFns";
import { Chat20Regular } from "@fluentui/react-icons";
import { InteractionCardBase } from "./InteractionBase";
import { ChannelType } from "@/common/constants/shared";

const genericConfig = {
	icon: <Chat20Regular />,
	detailsCard: MessagingDetailsCard,
	acceptFn: acceptGeneric,
	acceptTransferFn: acceptGenericTransfer,
	rejectFn: rejectGeneric,
	rejectTransferFn: rejectGenericTransfer,
	messageIntlId: "Interaction.Contents.GenericMessage",
};

export const GenericInteractionCard = () => {
	return (
		<InteractionCardBase
			channelType={ChannelType.Generic}
			channelConfig={genericConfig}
		/>
	);
};
